import React, { Component } from 'react';

import { Form } from 'react-form';
import { Input, Select } from '../Form';
import { required, formHasErrors } from '../../utils/form-validation';
import styles from '../Events/EventEditWizard/eventCreate.scss';

class ClubSelectForm extends Component {
    render() {
        const { clubsList } = this.props;

        return (
            <div className={`${styles.section} mt24`}>
                <Form onSubmit={values => this.props.handleSubmit(values)}>
                    {({ submitForm, errors }) => {
                        return (
                            <form onSubmit={submitForm} id="selectClubForm">
                                <Input id="dummy" field="dummy" type="hidden" />
                                <div className={`form-block-content`}>
                                    <div className="row bb pb24">
                                        <div className="col-12">
                                            <Select
                                                id={`clubId`}
                                                label="Your organizations"
                                                description="Select from the clubs, teams, and groups that you organize to create your new event."
                                                field={'clubId'}
                                                options={clubsList.map((club) => {
                                                    club.label = club.name;
                                                    club.value = club.name;
                                                    return club;
                                                })}
                                                validate={required}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {formHasErrors(errors) && (
                                    <div className="pt24 text-center text-error text-small">
                                        You must select an organization to create a new event.
                                    </div>
                                )}
                                <div className="row mb56 mt32">
                                    <div className="col-12 col-md-4 mb16">
                                        <button
                                            onClick={(ev) => {
                                                this.props.cancel(ev);
                                            }}
                                            type="button"
                                            className="btn btn-default btn-xl text-uppercase btn-block"
                                        >
                                            Back
                                        </button>
                                    </div>
                                    <div className="col-12 col-md-4 offset-md-4">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-xl text-uppercase btn-block"
                                        >
                                            Continue
                                        </button>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </div>
        );
    }
}

export default ClubSelectForm;
